<template>
  <section>
    <div class="wrapper wrapper-content">
      <div class="row">
        <div class="ibox-content">
          <div class="row">
            <div v-if="loggedInRole==='ROLE_ADMIN'">
              <div class="col-md-4">
                <div class="form-group">
                  <multiselect id="restaurant_filter" v-model="selectedRestaurant" :options="allRestaurants" label="name" track-by="name" @input="fetchBranchesOfRestaurant()"></multiselect>
                </div>
              </div>

              <div class="col-md-6 pull-right" v-if="!isSubscriptionExist && selectedRestaurant != null" v-bind:getElementByClass="true">
                <div class="col-md-3 pull-right">
                  <button class="btn btn-primary btn-md pull-right" @click="createSubscription()">Create Subscription</button>
                </div>
                <div class="col-md-5 pull-right" >
                  <input v-model="dateRange" type="text" readonly="readonly" placeholder="Select Start Date" class="form-control date_picker"/>
                </div>
              </div>

              <div class="row" v-if="selectedRestaurant !== null && pendingInvoicesIdsAndTotalAmount.length>0">
                <div class="col-md-8 pull-left" style="margin-left: 10px">
                  <div class="col-md-4">
                    <h4><b>Due Amount: </b>{{pendingInvoicesDetails.due_amount}}</h4>
                    <h4><b>Due Date: </b>{{pendingInvoicesDetails.due_date}}</h4>
                  </div>
                  <div class="col-md-2" style="margin-left: 50px">
                    <button @click="payPendingAmount()" class="btn btn-primary">Pay Now</button>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="loggedInRole==='ROLE_USER'">
              <div v-if="pendingInvoicesIdsAndTotalAmount.length>0">
                <h1 class="col-lg-6 text-left" style="margin-top: 25px; margin-left: 25px"><b>{{(selectedRestaurant!==null) ? selectedRestaurant.name : ""}}</b></h1>
                <div class="col-lg-2 pull-right" v-if="selectedRestaurant !== null">
                  <h4><b>Due Amount: </b>{{pendingInvoicesDetails.due_amount}}</h4>
                  <h4><b>Due Date: </b>{{pendingInvoicesDetails.due_date}}</h4>
                  <button @click="payPendingAmount()" class="btn btn-primary">Pay Now</button>
                </div>
              </div>
              <div v-else>
                <h1 class="text-center"><b>{{(selectedRestaurant!==null) ? selectedRestaurant.name : ""}}</b></h1>
              </div>
          </div>
        </div>
          <hr/>
          <div style="align:center" v-bind:class="'sk-spinner sk-spinner-three-bounce ' + isHideSpinner">
            <div class="sk-bounce1"></div>
            <div class="sk-bounce2"></div>
            <div class="sk-bounce3"></div>
          </div>
          <div v-if="selectedRestaurant!==null">
            <AllBranchesOfRestaurant ref="allBranchesOfRestaurants"
                                     v-bind:selectedRestaurant="selectedRestaurant"
                                     v-bind:branches="branches" />
            <div v-if="isSubscriptionExist">
              <CurrentBillingsStats ref="CurrentBillings"
                                    v-bind:billingStats="billingStats"
                                    v-bind:billingPeriod="billingPeriod"
                                    v-bind:selectedRestaurant="selectedRestaurant"/>
            </div>
            <SubscriptionsAndBillings ref="SubscriptionsAndBillings"
                                      v-bind:selectedRestaurant="selectedRestaurant"/>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import User from '@/services/User'
import Multiselect from 'vue-multiselect'
import AllBranchesOfRestaurant from '@/components/restaurants/AllBranchesOfRestaurant'
import SubscriptionsAndBillings from '@/components/billings/SubscriptionsAndBillings'
import CurrentBillingsStats from '@/components/billings/CurrentBillingsStats'
export default {
  name: "RestaurantSubscriptionAndBilling",
  data () {
    return {
      loggedInRole:'',
      dateRange: "",
      getElementByClass: false,
      start_date: "",
      allRestaurants:[],
      selectedRestaurant:null,
      branches:[],
      isHideSpinner: "hide",
      isSubscriptionExist:false,
      billingStats:{
        "total_orders":0,
        "cancelled_order":0,
        "commission":0.0
      },
      billingPeriod:{
        "start":"",
        "end":""
      },
      currentSubscription:'',
      subscriptionObj:{
        "subscriptionName": "DVM Standard Subscription",
        "restaurantId": {
          "id":0
        }
      },
      pendingInvoicesDetails: {
        "due_amount": 0.0,
        "due_date": "",
      },
      pendingInvoicesIdsAndTotalAmount: [],
    }
  },
  components: {
    Multiselect,
    AllBranchesOfRestaurant,
    SubscriptionsAndBillings,
    CurrentBillingsStats
  },
  computed:{
    restaurant(){
      return this.$store.state.user.restaurant;
    },
    refreshDatatable(){
      return this.$store.state.refreshBillingDatatable;
    }
  },
  async mounted() {
    if (this.$route.query.update !== undefined) {
      this.$http.put(this.$store.state.mainAppURL + "billings/update_invoices_status/" + JSON.parse(this.$route.query.update)).then(resp => {
        if (resp.data === true) {
          swal("SUCCESS!", "Paid successfully!", "success");
        }
      })
    }
    if (this.$route.query.res !== undefined) {
      let params = new URLSearchParams();
      params.append("restaurant_id", this.$route.query.res);
      await this.$http.post(this.$store.state.mainAppURL + "restaurants/get_restaurant_by_id", params).then(async resp => {
        this.selectedRestaurant = resp.data;
      });
    }
    this.$router.push("/restaurant_billings").catch(()=>{})
  },
  watch:{
    async getElementByClass(){
      if(this.selectedRestaurant!= null) {
        let resp = await this.$http.get(this.$store.state.mainAppURL + "billings/get_restaurant_last_invoice_end_date/" + this.selectedRestaurant.id)
        this.start_date = resp.data;
        setTimeout(() => {
          let self = this;
          let datepickerObject = $('.date_picker');
          datepickerObject.daterangepicker({
            format: 'YYYY-MM-DD',
            singleDatePicker: true,
            showDropdowns: false,
            minDate: this.start_date,
            maxYear: parseInt(moment().format('YYYY'), 10)
          }).on('apply.daterangepicker', function (ev, picker) {
            self.dateRange = (picker.startDate.format('YYYY-MM-DD'));
          }).on('cancel.daterangepicker', function (ev, picker) {
            self.dateRange = ('');
          });
        }, 500);
        this.getElementByClass = false;
      }
    },
    async selectedRestaurant() {
      this.isSubscriptionExist = false;
      this.getElementByClass = true;
      this.dateRange = "";
      await this.loadPendingInvoicesData();
    },
    async refreshDatatable(){
      if(this.$store.state.refreshBillingDatatable===true)
        await this.fetchBranchesOfRestaurant();
      this.dateRange = "";
    }
  },
  async beforeCreate(){
    await User.fetchUserRoles().then(async role => {
      this.loggedInRole = role;
      if(role === 'ROLE_ADMIN'){
        await this.$http.post(this.$store.state.mainAppURL + "restaurants/get_all_restaurants").then(resp => {
          this.allRestaurants = resp.data;
        });
      }else if(role === 'ROLE_USER'){
        this.selectedRestaurant = this.restaurant;
        this.allRestaurants.push({id: this.restaurant.id, name: this.restaurant.name});
        await this.fetchBranchesOfRestaurant();
        await this.loadPendingInvoicesData();
      }
    });
  },
  methods:{
    payPendingAmount: function (){
        this.$router.replace("/view_pending_invoices?res="+this.selectedRestaurant.id+"&stats="+ JSON.stringify(this.pendingInvoicesIdsAndTotalAmount));
    },
    loadPendingInvoicesData: async function () {
      let params = new URLSearchParams();
      params.append("restaurant_id", this.selectedRestaurant.id);
      await this.$http.get(this.$store.state.mainAppURL + "billings/get_due_amount_and_due_date", {
        params: params
      }).then(resp => {
        this.pendingInvoicesDetails = resp.data;
      });
      await this.$http.get(this.$store.state.mainAppURL + "billings/get_pending_invoices_stats", {
        params: params
      }).then(resp => {
        this.pendingInvoicesIdsAndTotalAmount = resp.data;
      })
    },
    fetchBranchesOfRestaurant: async function () {
      this.isHideSpinner="";
      if(this.selectedRestaurant!==null){
        let params = new URLSearchParams();
        params.append("restaurant_id", this.selectedRestaurant.id);
        await this.$http.post(this.$store.state.mainAppURL + "restaurants/get_all_branches", params).then(async resp => {
          this.branches = resp.data;
          await this.checkIsActiveSubscriptionExist()
          if(this.isSubscriptionExist){
            await this.getCurrentBillingsDetail();
          }
          this.getElementByClass= false;
          this.isHideSpinner="hide"
        });
      }
    },
    openBranchPopup: function(branchId, restaurantId, restaurantName) {
      this.$refs.addUpdateBranchPopUp.load(branchId, restaurantId, restaurantName);
    },
    checkIsActiveSubscriptionExist: async function(){
      let resp= await this.$http.get(this.$store.state.mainAppURL + "billings/is_subscription_exist/" + this.selectedRestaurant.id);
      if(resp.data !==null && resp.data!==''){
        this.currentSubscription= resp.data;
        this.isSubscriptionExist= true;
      }else{
        this.isSubscriptionExist=false;
      }
    },
    getCurrentBillingsDetail: async function(){
      let resp= await this.$http.get(this.$store.state.mainAppURL + "billings/current_month_billing_stats/" + this.selectedRestaurant.id)
      this.billingStats= resp.data;
      let billingPeriod= await this.$http.get(this.$store.state.mainAppURL + "billings/get_billing_period/" + this.selectedRestaurant.id)
      this.billingPeriod= billingPeriod.data;
    },
    createSubscription: async function(){
      if(this.dateRange===''){
        swal("Error!", "Kindly Select Date Range", "error");
        return;
      }
      Swal.fire({
        title: 'Please Wait! We are processing the data.',
        type: 'info',
        allowOutsideClick: false,
        allowEscapeKey: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
      this.subscriptionObj.restaurantId.id= this.selectedRestaurant.id;
      let params= new URLSearchParams();
      params.append("start_date", this.dateRange);
      let resp= await this.$http.post(this.$store.state.mainAppURL + "billings/create_subscription", this.subscriptionObj, {
        params: params,
      });
      Swal.close();
      swal("Success", "Subscription Has Been Created", "success");
      this.$store.dispatch("refreshBillingAndSubscriptionDatatable", true);
    }
  }
}
</script>